export default __webpack_public_path__ + "media/logos/primary_dark-f9c5298c.png";